import { styled } from "styled-components";

export const OrganizationContainer = styled.div``;

export const OrganizationWrapper = styled.div``;

export const OrganizationImgWrapper = styled.div`
  background: #f7f7f7;
  padding: 80px 0;
  img {
    width: 835px;
  }
  @media all and (max-width: 900px) {
    img {
      width: 100%;
    }
  }
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;
export const OrganizationContentsWrapper = styled.div`
  padding: 100px 0 120px;
  .title-wrap {
    font-size: 48px;
    line-height: 1.3;
    margin-bottom: 80px;
    color: #233e99;
    font-weight: bold;
  }
  .organization-ul {
    display: flex;
    gap: 40px;
    flex-wrap: wrap;
    > li {
      width: calc(50% - 20px);
      padding: 24px;
      display: flex;
      gap: 16px;
      border: 1px solid #dfdfdf;
      border-radius: 20px;
      .img-wrap {
        width: 240px;
        img {
          width: 100%;
          height: 340px;
          object-fit: cover;
        }
      }
      .text-wrap {
        display: flex;
        flex-direction: column;
        gap: 4px;
        .title {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 4px;
          p {
            font-size: 24px;
            line-height: 1.4;
            font-weight: bold;
            color: #242424;
          }
          a {
            width: 24px;
            height: 24px;
            background-color: #171717;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          img {
            width: 16px;
            height: 16px;
          }
        }
        .sub-title {
          margin-bottom: 16px;
          p {
            color: #555;
            font-size: 14px;
            line-height: 1.4;
            text-align: left;
            word-break: keep-all;
          }
        }
        > ul {
          li {
            color: #6f6f6f;
            text-align: left;
            word-break: keep-all;
            font-size: 12px;
            line-height: 1.3;
          }
        }
      }
    }
  }
  @media all and (max-width: 1180px) {
    .organization-ul {
      gap: 20px;
      > li {
        width: calc(50% - 10px);
        .img-wrap {
          width: 20.339vw;
          img {
            /* height: 28.814vw; */
            height: 23.729vw;
          }
        }
      }
    }
  }
  @media all and (max-width: 1024px) {
    .organization-ul {
      > li {
        flex-direction: column;
        gap: 20px;
      }
    }
  }
  @media all and (max-width: 768px) {
    padding: 13.021vw 0 15.625vw;
    .title-wrap {
      font-size: 6.25vw;
      margin-bottom: 10.417vw;
    }
    .organization-ul {
      gap: 2.604vw;
      > li {
        width: 100%;
        padding: 3.125vw;
        gap: 2.604vw;
        border-radius: 2.604vw;
        flex-direction: row;
        .img-wrap {
          width: 42.969vw;
          img {
            height: 49.479vw;
          }
        }
        .text-wrap {
          gap: 0.781vw;
          .title {
            gap: 1.302vw;
            margin-bottom: 0.781vw;
            p {
              font-size: 3.906vw;
            }
            a {
              width: 5.469vw;
              height: 5.469vw;

              border-radius: 2.604vw;
            }
            img {
              width: 3.906vw;
              height: 3.906vw;
            }
          }
          .sub-title {
            margin-bottom: 2.604vw;
            p {
              font-size: 3.125vw;
            }
          }
          > ul {
            li {
              font-size: 3.125vw;
            }
          }
        }
      }
    }
  }
  @media all and (max-width: 500px) {
    .organization-ul {
      > li {
        flex-direction: column;
      }
    }
  }
`;
